import React, { useState, useEffect, Component } from "react";
import { useParams } from "react-router-dom";
import { downloadItems } from "./Blog";
import { Link } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./carddetail.css";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import moment from 'moment';
import BlogMobileNav from "./blogmobilenav";


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});


const CardDetail = () => {

   const[heroBanner, setHeroBanner] = useState([])
   const [heading, setHeading] = useState("")
   const [date, setDate] = useState("")
   const [category, setCategory] = useState("")
   const [categoryId, setCategoryId] = useState("")
   const [blogContent, setBlogContent] = useState([])
   const [otherPosts, setOtherPosts] = useState([])
                 
      
const params = useParams()
 useEffect( () => {
   client
   .query({
     query: gql`
     query($id:ID!){
      blogsBy(id:$id) {
    blogs {
      body {
        contentarea
        image {
          mediaItemUrl
        }
        list {
          images {
            mediaItemUrl
          }
          items
        }
        subheading
        text
        textcontent
      }
      coverImage {
        mediaItemUrl
      }
      heading
    }
    date
    
    categories {
      nodes {
        name
        databaseId
      }
      
    }
  }
   }
   `,
   variables: {id:params.id}
   })
   .then(async result => { 
    console.log(result)
  setBlogContent(result.data.blogsBy.blogs.body)
  setHeroBanner(result.data.blogsBy.blogs.coverImage.mediaItemUrl)
  setHeading(result.data.blogsBy.blogs.heading)
   setDate(moment(result.data.blogsBy.date).format("MMM Do YYYY"))
    setCategory(result.data.blogsBy.categories.nodes[0].name)
    setCategoryId(result.data.blogsBy.categories.nodes[0].databaseId)


      client
   .query({
     query: gql`
     query($id: Int!){
       blog(where: {categoryId: $id}) {
    edges {
      node {
      id
        blogs {
          
          heading
          coverImage {
            mediaItemUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        date
      }
    }
  }
   }
   `,
   variables: {id:result.data.blogsBy.categories.nodes[0].databaseId}
   })
   .then(async result => { 
    console.log(result)
  
  setOtherPosts(result.data.blog.edges)


   })

   })




}, [])   

  const { id } = useParams();
  const item = downloadItems.find((item) => item.id === parseInt(id));
  const otherItems = downloadItems
    .filter((item) => item.id !== parseInt(id))
    .slice(0, 4);
  console.log(item);

  let blogContentDisplay 

    blogContentDisplay = blogContent.map((content, i) => 
     
        content.textcontent ? 

          <p className="cardinr-p"> {content.text} </p>

        : content.subheading ? 
  
        <h5 className="cardinr-p"> {content.text} </h5> 

        : content.contentarea ? 

          <img src={content.image.mediaItemUrl} width="100%"     />  

       : content.list?

         <ul> 
          {content.list.map((items,i )=>
         <li className="orange"> {items.items} </li>
        )}
         
         </ul>
        
        
        :

        <p> no items </p>
    )

  return (
    <>
      <div className="card-detail">
        <h2 className="crddtl-h2">{heading}</h2>
        <div className="subtitle">
          <p className="card-text inner-txt" style={{ fontWeight: "450" }}>
            {date}
          </p>
          <span className="full-stop">•</span>
          <p className="card-text inner-txt" style={{ fontWeight: "450" }}>
            {category}
          </p>
        </div>
        <div
          className="card-dtlimg"
          style={{
            backgroundImage: `url(${heroBanner})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
            width: "100%",
          }}
        />


        {blogContentDisplay}



  
      </div>

  <div className="crd-parent">
        <div className="allposts">
          <h3>Other Blog Posts</h3>
          <Link to="/blog">  See All Blog </Link>
        </div>
        <div className="otherItems">
          {otherPosts.map((item) => {
            return (
              <Link
                to={`/blog-single/${item.node.id}`}
                key={item.node.id}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div id="innerblog-crd" className=" crd card ">
                  <div style={{ padding: "0.64rem" }}>
                    <div
                      id="crd-top"
                      style={{
                        width: "200px",
                        backgroundImage: `url(${item.node.blogs.coverImage.mediaItemUrl})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        borderRadius: "0.5rem",
                        height: "215px",
                      }}
                    ></div>
                  </div>

                  <div id="inner-body" className="card-body">
                    <p className="mb-3 p-head">   {item.node.categories.nodes[0].name} </p>
                    <h5
                      className="card-title crd-ttl "
                      style={{ fontSize: "18px !important", fontWeight: "500" }}
                    >
                      {item.node.blogs.heading}
                    </h5>
                    <p
                      className="card-text crd-txt mt-2"
                      style={{ fontWeight: "500" }}
                    >
                        {moment(item.node.date).format("MMM Do YYYY")}
                      <GoDotFill
                        className="ms-1 me-1"
                        style={{ fontSize: "8px" }}
                      />
                   {item.node.categories.nodes[0].name}
                    </p>
                    <hr
                      style={{
                        border: "0",
                        borderTop: "2px dashed #e9e8e8ff",
                        borderImage:
                          "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
                      }}
                    />
                    <div className="Read-more d-flex align-items-center">
                      <FontAwesomeIcon
                        className="chv-dwn-arr "
                        icon={faArrowRight}
                        style={{
                          color: "#fe7914",
                          fontSize: "8px",
                          fontWeight: "light",
                          backgroundColor: "#FFEACC",
                          padding: "13.5px",
                        }}
                      />{" "}
                      <span class="lrn-more ms-2"> Learn More </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CardDetail;
